<script>
import tableMixin from './table'

export default {
  mixins: [tableMixin],
  methods: {
    rowClicked (item) {
      this.$router.push({
        name: this.rowClickRoute,
        params: {
          [this.routeParamName]: item.id
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/mixins/client-table.vue